// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ReorderPadSummaryCard from "@adl/App/Widgets/ReorderPad/ReorderPadSummaryCard";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow, { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    products: ProductModel[];
}

interface ReorderPadTableStyles {
    container?: InjectableCss;
    dataTable?: DataTableProps;
    tableHeader?: DataTableHeaderProps;
    dataTableRow?: DataTableRowProps;
}

const reorderPadTableStyles: ReorderPadTableStyles = {
    container: {
        css: css`
            overflow: auto;
        `,
    },
};

const styles = reorderPadTableStyles;
const ReorderPadTable: FC<OwnProps> = ({ products }) => {
    return (
        <StyledWrapper {...styles.container}>
            <DataTable {...styles.dataTable}>
                <DataTableHead>
                    <DataTableHeader {...styles.tableHeader}>{translate("Product Image")}</DataTableHeader>
                    <DataTableHeader {...styles.tableHeader}>{translate("Product Description")}</DataTableHeader>
                    <DataTableHeader {...styles.tableHeader}>{translate("Order QTY")}</DataTableHeader>
                    <DataTableHeader {...styles.tableHeader}>{translate("Pricing / Inventory")}</DataTableHeader>
                    <DataTableHeader {...styles.tableHeader}>{translate("Actions")}</DataTableHeader>
                </DataTableHead>
                <DataTableBody>
                    {products.map(product => (
                        <DataTableRow {...styles.dataTableRow} key={product.id}>
                            <ReorderPadSummaryCard product={product} />
                        </DataTableRow>
                    ))}
                </DataTableBody>
            </DataTable>
        </StyledWrapper>
    );
};

export default ReorderPadTable;
